import React, { useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import img1 from "../../../assets/dataAnalysis.gif";
import img2 from "../../../assets/timeVertical.gif";
import img3 from "../../../assets/growth.gif";
import img4 from "../../../assets/upsellRevenue.gif"

gsap.registerPlugin(ScrollTrigger);

const Section3 = () => {
  useEffect(() => {
    const details = gsap.utils.toArray(".desktopContentSection:not(:first-child)");
    const photos = gsap.utils.toArray(".desktopPhoto:not(:first-child)");

    // Initially hide all images except the first one
    gsap.set(photos, { autoAlpha: 0 });

    let mm = gsap.matchMedia();

    mm.add("(min-width: 600px)", () => {
      ScrollTrigger.create({
        trigger: ".gallery",
        start: "top top",
        end: "bottom bottom",
        pin: ".right"
      });

      details.forEach((detail, index) => {
        let headline = detail.querySelector("h2");
        let animation = gsap.timeline()
          .to(photos[index], { autoAlpha: 1 }) // Show the current image
          .to(photos[index === 0 ? photos.length - 1 : index - 1], { autoAlpha: 0 }); // Hide the previous image

        ScrollTrigger.create({
          trigger: headline,
          start: "top 70%",
          end: "top 40%",
          animation: animation,
          scrub: true,
          markers: false
        });
      });
    });

    return () => mm.revert();
  }, []);

  const data = [
    {
      title : "State of the art solutions to increase revenue by 15% - 20% per guest",
      description : "Digitally showcase amenities and services to guests, eliminating manual barriers and enhancing accessibility. From check-in to checkout, our solution creates upsell opportunities throughout the guest's stay, while elevating the overall stay experience."
    },
    {
      title: "Boost operational efficiency by 20% - 30% with smart task allocation",
      description: " Smart task allocation for routine activities frees up valuable staff time, enabling employees to focus on higher-value tasks. This leads to improved efficiency, consistent service, and reduced costs."
    },
    {
      title : 'Make informed decisions with data driven insights for your hotel',
      description : "Our solution delivers actionable analytics with real-time insights into guest behavior & spendings, services & amenities utilization, and revenue & staff performance trends. Leverage this data to optimize operations, enhance guest experiences, and drive profitability."
    },
    {
      title: "Gain an edge over competition in hospitality space by leveraging technology",
      description: "Stand out in the competitive hospitality industry by embracing innovative strategies. From personalized services to advanced technology, offering unique value propositions will attract more guests, enhance loyalty, and strengthen your market position."
    }
  ];

  return (
    <div className="bg-[#FFFF] text-[#333] ">
      {/* <div className="spacer bg-[#ffff] w-full h-[18vh]"></div> */}

      <div className="gallery flex">
        
        <div className="left w-1/2 ">
          <div className="desktopContent mx-auto w-4/5">
            {data.map((data, index) => (
              <div key={index} className="desktopContentSection min-h-[100vh] flex flex-col justify-center max-w-[420px]">
                <h2 className="text-4xl font-bold" style={{ lineHeight: "45px" }}>
                  {data.title}
                </h2>
                <p className="mt-8 text-gray-400">
                  {data.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="right w-1/2 h-[100vh] flex flex-col justify-center lg:pe-[70px]">
          <div className="desktopPhotos ml-auto w-[40vw] h-[40vw] rounded-[20px] relative overflow-hidden shadow-[3px_3px_3px_rgba(0,0,0,0.4)]">
            {[img4,img2,img1,img3].map((img, index) => (
              <img
                key={index}
                src={img}
                alt="Alfred | Smart Hotel Platform for Revenue & Guest Experience"
                className="desktopPhoto absolute w-full h-full object-cover"
                title = "Alfred | Smart Hotel Platform for Revenue & Guest Experience"
              />
            ))}
          </div>
        </div>

      </div>
    </div>
  );
};

export default Section3;